import ModelosFaturamentoService from "@/services/ModelosFaturamentoService";

export const modelosFaturamento = {
  namespaced: true,
  state: {
    modelosFaturamento: {},
  },
  actions: {
    getModelosFaturamento({ commit }, payload) {
      return ModelosFaturamentoService.GetModelosFaturamento(payload).then(
        (modelosFaturamento) => {
          return Promise.resolve(modelosFaturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postModelosFaturamento({ commit }, payload) {
      return ModelosFaturamentoService.PostModelosFaturamento(payload).then(
        (modelosFaturamento) => {
          return Promise.resolve(modelosFaturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putModelosFaturamento({ commit }, payload) {
      return ModelosFaturamentoService.PutModelosFaturamento(payload).then(
        (modelosFaturamento) => {
          return Promise.resolve(modelosFaturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteModelosFaturamento({ commit }, payload) {
      return ModelosFaturamentoService.DeleteModelosFaturamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getModelosFaturamentoOData({ commit }, payload) {
      return ModelosFaturamentoService.GetModelosFaturamentoOData(payload).then(
        (modelosFaturamento) => {
          return Promise.resolve(modelosFaturamento);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default modelosFaturamento;
